import React, { useEffect, useState, useRef, useContext } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import axios from 'axios'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import moment from 'moment-timezone'

import {
  Grid,
  Box,
  Paper,
  Typography,
  Checkbox,
  Button,
  TextField,
  FormControl,
  FormGroup,
  FormControlLabel
} from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

import Title from '../components/atoms/Title'
import SelectInput from '../components/atoms/SelectInput'
import SelectInputCategory from '../components/atoms/SelectInputCategory'
import CenteredSubmitButton from '../components/molecules/CenteredSubmitButton'
import DateTimePicker from '../components/molecules/DateTimePicker'
import ImagePicker from '../components/molecules/ImagePicker'
import UploadAndEditImage from '../components/organisms/UploadAndEditImage'
import DefaultTab from '../components/organisms/DefaultTab'
import TinyMCE from '../components/organisms/TinyMCE'
import InputExternalLink from '../components/organisms/InputExternalLink'
import InputFileLink from '../components/organisms/InputFileLink'
import InputCategory from '../components/organisms/InputCategory'

import { Notification } from '../types/Notification'
import { Admin } from '../types/Admin'
import { Category } from '../types/Category'
import { formUploadHelper } from '../helpers'
import store from '../store'
import { setAuth } from '../store/actions/auth'
import ConfigContext from '../ConfigContext'

const validUrl = require('valid-url')

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    height: `100%`
  },
  textField: {
    paddingRight: theme.spacing(1)
  }
}))
const noImage = process.env.REACT_APP_NOIMAGE

const NotificationCMS: React.FC<
  RouteComponentProps<{ notification_id: string }> &
    ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>
> = ({ match, history, admin, setAuth }) => {
  const notificationId = match.params.notification_id
  const currentPath = match.path
  const classes = useStyles({})
  const [notification, setNotification] = useState<{
    title: string
    content: string
    external_link: string
    file_link: string
    icon: string
    release_date: Date | null
    close_date: Date | null
    invisibled_date_flg: boolean
    important_flg: boolean
    hot_news_flg: boolean
    close_flg: boolean
    category: number | null
    sender: string
    member_site_flg: boolean
  }>({
    title: '',
    content: '',
    external_link: '',
    file_link: '',
    icon: '',
    release_date: moment({ hour: 0 }).toDate(),
    close_date: null,
    invisibled_date_flg: false,
    important_flg: false,
    hot_news_flg: false,
    close_flg: false,
    category: null,
    sender: '',
    member_site_flg: false
  })
  const [fileObject, setFileObject] = useState<File | null>(null)
  // s3対応
  // const [fileObject, setFileObject] = useState<{ file: File | null; filename: string }>({
  //   file: null,
  //   filename: ''
  // })
  const [fileName, setFileName] = useState<string>('')
  const [uploadedImages, setUploadedImages] = useState<string[]>([])
  // s3対応
  // const [uploadedImages, setUploadedImages] = useState<{ preview: string; key: string }[]>([])
  const [admins, setAdmins] = useState<{ value: string; label: string }[]>([])
  const [modalState, setModalState] = useState(false)
  const [modalStateCategory, setModalStateCategory] = useState(false)
  const [type, setType] = useState<'create' | 'edit'>('create')
  const [initTab, setInitTab] = useState<number>(1)
  const [category, setCategory] = useState<Category[]>([])
  const [deleteFileLink, setDeleteFileLink] = useState<string>('')
  const editorRef = useRef(null)
  const config = useContext(ConfigContext)

  const tabs = [
    {
      value: 1,
      label: '文字情報',
      component: (
        <TinyMCE
          initialValue={notification.content}
          editorRef={editorRef}
          inputHandler={(tinyMCEContent: string) => {
            setDeleteFileLink(notification.file_link)
            setNotification({
              ...notification,
              content: tinyMCEContent,
              external_link: '',
              file_link: ''
            })
            setFileObject(null)
            // s3対応
            // setFileObject({
            //   file: null,
            //   filename: ''
            // })
          }}
        />
      )
    },
    {
      value: 2,
      label: '外部リンク設定',
      component: (
        <InputExternalLink
          value={notification.external_link}
          checked={
            config.enableNotificationsMemberSiteFlg === '1' ? notification.member_site_flg : null
          }
          inputHandler={(input: string) => {
            setDeleteFileLink(notification.file_link)
            setNotification({
              ...notification,
              content: '',
              external_link: input,
              file_link: ''
            })
            editorRef.current.editor.setContent('')
            setFileObject(null)
            // s3対応
            // setFileObject({
            //   file: null,
            //   filename: ''
            // })
          }}
          checkHandler={(checked: boolean) => {
            setNotification({
              ...notification,
              member_site_flg: checked
            })
          }}
        />
      )
    },
    {
      value: 3,
      label: 'ファイルリンク設定',
      component: (
        <InputFileLink
          fileObject={fileObject}
          inputHandler={(input: File) => {
            if (notification.file_link) {
              setDeleteFileLink(notification.file_link)
            }
            setNotification({
              ...notification,
              content: '',
              external_link: ''
            })
            editorRef.current.editor.setContent('')
            setFileObject(input)
            // s3対応
            // setFileObject({
            //   file: input,
            //   filename: ''
            // })
          }}
          deleteHandler={() => {
            setDeleteFileLink(notification.file_link)
            setFileObject(null)
            // s3対応
            // setFileObject({
            //   file: null,
            //   filename: ''
            // })
            setNotification({
              ...notification,
              file_link: ''
            })
          }}
          changeFilenameHandler={filename => setFileName(filename)}
        />
      )
    }
  ]

  /**
   * uriからFileオブジェクトを作成する関数
   * @param uri
   * @param fileName
   */
  const getFileObjectFromURI = async (uri: string, fileName: string) => {
    const { data } = await axios.get(uri, {
      responseType: 'arraybuffer'
    })
    return new File([data as ArrayBuffer], fileName)
  }

  const fetchImages = async () => {
    const { data } = await axios.get<string[]>(`/upload/admin`)
    data.unshift('/static/images/default/no_image.png')
    setUploadedImages(data)
    if (currentPath === '/create-notification') {
      setNotification({ ...notification, icon: data[0] })
    }
    // s3対応
    // const images: { preview: string; key: string }[] = []
    // images.push({ preview: config.serverHost + noImage, key: noImage })
    // for (const row of data) {
    //   images.push({
    //     preview: `${config.serverHost}/upload/image/?key=${encodeURIComponent(row)}`,
    //     key: row
    //   })
    // }
    // setUploadedImages(images)
  }

  const fetchCategory = async () => {
    try {
      const { data } = await axios.get<Category[]>(`notifications/category`)
      setCategory(data)
    } catch (error) {
      alert(error.message)
    }
  }

  /**
   * 初期化処理
   */
  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const { data } = await axios.get<Notification>(`/notifications/${notificationId}`)
        if (data.file_link) {
          const originalFileName = data.file_link.replace(/\/static\/upload\/.*\//, '')
          setFileObject(await getFileObjectFromURI(data.file_link, originalFileName))
          // s3対応
          // setFileObject({
          //   file: null,
          //   filename: `${config.serverHost}/upload/image/?key=${encodeURIComponent(data.file_link)}`
          // })
        }
        setNotification({
          title: data.title,
          content: data.content,
          external_link: data.external_link,
          file_link: data.file_link,
          icon: data.icon,
          release_date: moment(data.release_date).toDate(),
          close_date: data.close_date ? moment(data.close_date).toDate() : null,
          invisibled_date_flg: Boolean(data.invisibled_date_flg),
          important_flg: Boolean(data.important_flg),
          hot_news_flg: Boolean(data.hot_news_flg),
          close_flg: Boolean(data.close_flg),
          category: data.category,
          sender: data.sender,
          member_site_flg: Boolean(data.member_site_flg)
        })
        if (data.content) {
          setInitTab(1)
        } else if (data.external_link) {
          setInitTab(2)
        } else if (data.file_link) {
          setInitTab(3)
        }
      } catch (error) {
        alert(error.message)
      }
    }

    const fetchAdmins = async () => {
      const { data } = await axios.get<Admin[]>(`/admins`)
      setAdmins(
        data.map(admin => ({
          value: admin.name,
          label: admin.name
        }))
      )
      const loginAdmin = data.filter(d => d.admin_id === admin.adminId)
      setAuth(admin.id, admin.token, admin.adminId, admin.password, loginAdmin[0].name)
    }

    fetchAdmins()
    fetchImages()

    // 現在のパスから新規作成処理なのか、更新処理なのかを判断する
    if (currentPath === '/create-notification') {
      setType('create')
      notification.sender = admin.name
      notification.icon = noImage
    } else {
      setType('edit')
      fetchNotification()
    }

    fetchCategory()
  }, [])

  /**
   * 登録
   */
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault()
      if (moment(notification.release_date) > moment(notification.close_date)) {
        alert('掲載開始日時を、掲載終了日時より後に設定することはできません。')
        return
      }
      if (type !== 'create') {
        const { data } = await axios.get<{ notification: Notification; member_flg: number }>(
          `/notifications/push-byarticle/${notificationId}`
        )
        await fetchCategory()
        const _category = category.filter(c => c.id == notification.category)
        if (
          data.notification.push_reserved_date &&
          !data.notification.push_at &&
          data.notification.push_member_flg !== _category[0].member_flg
        ) {
          alert(
            'プッシュ通知送信が予約されているためカテゴリを変更できません。予約を取り消してください。'
          )
          return
        }
      }
      if (notification.external_link && !validUrl.isWebUri(notification.external_link)) {
        alert('不正なリンクURLです。変更してください。')
        return
      }
      if (!notification.external_link && notification.member_site_flg) {
        alert('会員のシームレスログインを許可する場合は外部リンクのURLを入力してください。')
        return
      }

      let fileLink: string = ''
      if (fileObject instanceof File) {
        fileLink = await formUploadHelper(fileName, fileObject, '/upload/notification', true)
        // s3対応
        // if (fileObject.file instanceof File) {
        //   fileLink = await formUploadHelper(fileName, fileObject.file, '/upload/notification', true)
      }
      if (deleteFileLink) {
        await axios.delete('/upload', {
          data: { path: deleteFileLink }
        })
      }

      const requestBody = {
        ...notification,
        release_date: notification.release_date
          ? moment(notification.release_date).format('YYYY-MM-DD HH:mm')
          : null,
        close_date: notification.close_date
          ? moment(notification.close_date).format('YYYY-MM-DD HH:mm')
          : null,
        file_link: fileLink ? fileLink : notification.file_link
      }
      if (type === 'create') {
        // 新着情報を新規作成の場合
        await axios.post(`/notifications`, requestBody)
      } else {
        // 新着情報更新の場合
        await axios.put(`/notifications/${notificationId}`, requestBody)
      }
      history.push('/')
    } catch (error) {
      alert(error.message)
    }
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Box display="flex" justifyContent="space-between">
            <Title>お知らせの新規作成／編集</Title>
            <Box ml={3}>
              <Button color="primary" variant="outlined" href="/">
                一覧に戻る
              </Button>
            </Box>
          </Box>
          <form onSubmit={handleSubmit}>
            <Box>
              <Typography variant="subtitle2" color="error">
                ※は必須項目です。
              </Typography>
            </Box>

            <Box mb={5}>
              <Grid container alignItems="center" spacing={3}>
                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">
                    記事のタイトル
                    <Typography variant="caption" color="error" style={{ marginLeft: '3px' }}>
                      ※
                    </Typography>
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={5}>
                  <Box width={400}>
                    <TextField
                      value={notification.title}
                      variant="outlined"
                      placeholder="記事のタイトルを入力"
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setNotification({
                          ...notification,
                          title: event.target.value
                        })
                      }
                      fullWidth
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">
                    発信者
                    <Typography variant="caption" color="error" style={{ marginLeft: '3px' }}>
                      ※
                    </Typography>
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={5}>
                  <SelectInput
                    value={notification.sender}
                    selectHandler={(select: string) => {
                      admins.forEach((admin, index) => {
                        if (select === admin.value) {
                          setNotification({
                            ...notification,
                            sender: admin.value
                          })
                        }
                      })
                    }}
                    options={admins}
                    width={400}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">
                    掲載開始日時
                    <Typography variant="caption" color="error" style={{ marginLeft: '3px' }}>
                      ※
                    </Typography>
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={5}>
                  <Box width={400}>
                    <DateTimePicker
                      pickerHandler={(date: Date | null) => {
                        console.log(date)
                        setNotification({
                          ...notification,
                          release_date: date
                        })
                      }}
                      value={notification.release_date}
                      required
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">掲載終了日時</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={5}>
                  <Box width={400}>
                    <DateTimePicker
                      pickerHandler={(date: Date | null) => {
                        setNotification({
                          ...notification,
                          close_date: date
                        })
                      }}
                      value={notification.close_date}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">
                    カテゴリ
                    {category.length > 0 && (
                      <Typography variant="caption" color="error" style={{ marginLeft: '3px' }}>
                        ※
                      </Typography>
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={11}>
                  <Box display="flex">
                    {category.length > 0 && (
                      <Box display="flex" alignItems="center" mr={5}>
                        <SelectInputCategory
                          value={notification.category}
                          selectHandler={(select: string) => {
                            category.forEach(c => {
                              if (select === String(c.id)) {
                                setNotification({
                                  ...notification,
                                  category: c.id
                                })
                              }
                            })
                          }}
                          options={category.map(category => ({
                            value: String(category.id),
                            label: category.category,
                            caption: category.member_flg === 1 ? '（会員限定）' : ''
                          }))}
                          width={400}
                          required
                        />
                      </Box>
                    )}

                    <Box display="flex" alignItems="center" mr={5}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          setModalStateCategory(true)
                        }}
                      >
                        カテゴリを編集
                      </Button>
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">フラグ</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={11}>
                  <Box display="flex" alignItems="center" mr={5}>
                    <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
                      <FormGroup aria-label="position" row>
                        <FormControlLabel
                          value="top"
                          control={
                            <Checkbox
                              checked={notification.important_flg}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                                checked: boolean
                              ) =>
                                setNotification({
                                  ...notification,
                                  important_flg: checked
                                })
                              }
                            />
                          }
                          label="重要"
                          labelPlacement="end"
                        />
                      </FormGroup>
                    </FormControl>
                    <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
                      <FormGroup aria-label="position" row>
                        <FormControlLabel
                          value="top"
                          control={
                            <Checkbox
                              checked={notification.close_flg}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                                checked: boolean
                              ) =>
                                setNotification({
                                  ...notification,
                                  close_flg: checked
                                })
                              }
                            />
                          }
                          label="非公開"
                          labelPlacement="end"
                        />
                      </FormGroup>
                    </FormControl>

                    <FormControl component="fieldset" style={{ marginLeft: '1rem' }}>
                      <FormGroup aria-label="position" row>
                        <FormControlLabel
                          value="top"
                          control={
                            <Checkbox
                              checked={notification.invisibled_date_flg}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                                checked: boolean
                              ) =>
                                setNotification({
                                  ...notification,
                                  invisibled_date_flg: checked
                                })
                              }
                            />
                          }
                          label="掲載日を表示しない"
                          labelPlacement="end"
                        />
                      </FormGroup>
                    </FormControl>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={2} md={1}>
                  <Typography variant="subtitle2">登録アイコン</Typography>
                </Grid>
                <Grid item xs={12} sm={10} md={11}>
                  <Typography variant="caption" paragraph>
                    アイコンを以下から選択してください
                  </Typography>
                  <ImagePicker
                    options={uploadedImages}
                    initValue={notification.icon}
                    pickHandler={picked =>
                      setNotification({
                        ...notification,
                        icon: picked
                      })
                    }
                  />
                  <Box mb={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setModalState(true)
                      }}
                    >
                      アイコンをアップロード
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box my={3}>
              <Box>
                <DefaultTab tabs={tabs} initTab={initTab} />
              </Box>
            </Box>
            <Box mb={10}>
              <CenteredSubmitButton
                submittable
                resettable
                submitHandler={() => {
                  // handleSubmit()
                }}
                resetHandler={() => {
                  window.location.reload()
                }}
                size="large"
              />
            </Box>
          </form>
        </Paper>
      </Grid>

      <UploadAndEditImage
        isOpen={modalState}
        handleClose={() => {
          setModalState(false)
        }}
        handleRefresh={() => fetchImages()}
        handleUpdateNotification={key => {
          if (key === notification.icon) {
            setNotification({
              ...notification,
              icon: noImage
            })
          }
        }}
      />
      {modalStateCategory && (
        <InputCategory
          isOpen={modalStateCategory}
          handleClose={async () => {
            setModalStateCategory(false)
            await fetchCategory()
            category.map(d => String(d.id)).indexOf(String(notification.category)) == -1 &&
              setNotification({
                ...notification,
                category: null
              })
          }}
          handleRefresh={async () => {
            fetchCategory()
          }}
        />
      )}
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setAuth: (id: number, token: string, adminId: string, password: string, name: string) =>
      dispatch(setAuth(id, token, adminId, password, name))
  }
}

const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  return {
    admin: state.auth
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationCMS)
